import { requestContext } from "./request_context";

/**
 * Suppress the platform's long-press link/context overlays inside the native apps.
 *
 * Android WebView surfaces its long-press link tooltip / selection UI through the unhandled
 * `contextmenu` event, so cancelling it app-wide removes those overlays. Gated to the native
 * apps: on the web the same event is desktop right-click, which must keep working.
 *
 * The iOS equivalents are handled elsewhere: `-webkit-touch-callout: none` in the surface
 * stylesheets, and `allowsLinkPreview = false` on the WKWebView (app repo).
 *
 * The `dragstart` cancel kills iOS's long-press-and-drag link "lift" (the floating
 * title + URL preview). CSS `-webkit-user-drag: none` should do this alone, but a known
 * WebKit bug ignores it on `a[href]` sometimes — cancelling the event is the reliable layer.
 *
 * Call once from each native-loaded bundle entry. Listeners are document-level and permanent —
 * page lifetime, nothing to tear down.
 */
export function suppressNativeLongPressMenus(providedDocument = document) {
    if (!requestContext.isNativeApp()) return;
    providedDocument.addEventListener('contextmenu', event => event.preventDefault());
    providedDocument.addEventListener('dragstart', event => event.preventDefault());
}
